import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { Group } from 'app/model/dataflow/group';
import { IGroup } from './IDataflow';
import { DataFlow } from 'app/model/dataflow/dataflow';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(Group),
    asynchronous: true
})
export class GroupAdapter extends TransformationAdapter<Group> {
    public async getDslScript(group: Group): Promise<string> {
        return '';
    }

    public async _toModel(resource: IGroup, model: Group, dataflow?: DataFlow): Promise<Group> {
        model.name = resource.name;
        model.description = resource.description;
        resource.transformations.forEach((transformation) => model.transformations.add(transformation));
        return model;
    }

    public async _toResource(group: Group): Promise<IGroup> {
        return {
            name: group.name,
            description: group.description,
            transformations: Array.from(group.transformations)
        };
    }
}
